module.exports = "/assets/_next/static/images/nav-promo-810974b5613e101e6a4d226a2260fc94.png";